export default __webpack_public_path__ + "static/technologyrace-24fe981048de989e9fcca5a75a3b2614.jpg";